module.exports = __webpack_public_path__ + "static/scale-model-of-golden-visitors-center-in-lakewood-colorado-d89e8b0b18e8d727fedfbfcfea88827f.png";